__turbopack_context__.v({
  "collapse": "_1rkx2a_collapse",
  "content": "_1rkx2a_content",
  "contentHorizontal": "_1rkx2a_contentHorizontal",
  "horizontal": "_1rkx2a_horizontal",
  "unmounted": "_1rkx2a_unmounted",
  "vertical": "_1rkx2a_vertical",
});
